function o(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
function u(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    if (e === r || o(r) && r.test(e))
      return !0;
  }
  return !1;
}
export {
  u as default
};
//# sourceMappingURL=contact-channels88.js.map
